export const ETH_TOKENS = [
  'ETH',
  'WETH',
  'frxETH',
  'rETH',
  'cbETH',
  'stETH',
  'wstETH',
  'ezETH',
  'weETH',
  'weETHs',
  'rsETH',
  'wrsETH',
  'agETH',
  'msETH',
  'pxETH',
  'rswETH',
  'swETH',
  'ynETHx',
  'mETH',
  'wsuperOETHb',
  'tETH',
  'pufETH',
  'UETH',
  'ETHx',
  'osETH',
  'waEthWETH',
  'yETH',
  'WETH.e',
  'vbETH',
]

export const EURO_COINS = ['EURS', 'EURA', 'EURC', 'EURe', 'EURCV']

export const STABLE_COINS = [
  'DAI',
  'DAI.e',
  'MAI',
  'USDA',
  'USDC',
  'USDC.e',
  'USDT',
  'USDt',
  'USD₮',
  'USDP',
  'USDS',
  'TUSD',
  'GUSD',
  'FRAX',
  'USDbC',
  'LUSD',
  'sUSD',
  'USDM',
  'crvUSD',
  'mkUSD',
  'USDe',
  'PYUSD',
  'DOLA',
  'GHO',
  'eUSD',
  'USD0',
  'AUSD',
  'USR',
  'USDQ',
  'cUSD',
  'lvlUSD',
  'eUSDe',
  'RLUSD',
  'rUSD',
  'sDAI',
  'sUSDe',
  'sUSDS',
  'USD0++',
  'verUSDC',
  'wM',
  'wstUSR',
  'wUSDL',
  'WXDAI',
  'USN',
  'srUSD',
  'sDOLA',
  'sUSDC',
  'sUSDf',
  'USD₮0',
  'BOLD',
  'sBOLD',
  'YUSD',
  'USDX',
  'USD1',
  'sUSDX',
  'YU',
  'USDtb',
  'FDUSD',
  'USDT0',
  'iUSD',
  'USDf',
  'USDG',
  'waEthUSDT',
  'waEthUSDC',
  'USDaf',
  'frxUSD',
  'pUSDe',
  'savUSD',
  'srUSDe',
  'sUSDaf',
  'sUSDai',
  'USDai',
  'msUSD',
  'MUSD',
  'reUSD',
  'USDm',
  'vbUSDC',
  'vbUSDT',
  'USDH',
  'fxUSD',
  'apxUSD',
  'USDHL',
  'bbqUSDC',
  'apxUSD',
  'U',
  'NUSD',
  'yzUSD',
  'lisUSD',
  'trUSD',
  'USST',
  'mUSD',
]

export const BTC_TOKENS = [
  'LBTC',
  'cbBTC',
  'SolvBTC',
  'tBTC',
  'WBTC',
  'eBTC',
  'kBTC',
  'BTCB',
  'UBTC',
  'BTC.b',
  'WBTC.e',
  'vbWBTC',
  'hemiBTC',
]

export const SYMBOL_ALIASES: Record<string, string[]> = {
  ETH: ['WETH', 'frxETH', 'vbETH'],
  USDP: ['PAX'],
  USDC: ['USDbC', 'verUSDC', 'USDC.e', 'vbUSDC'],
  SEAM: ['esSEAM'],
  DAI: ['WXDAI', 'XDAI'],
  MATIC: ['POL'],
  USDS: ['vbUSDS'],
  USDT: ['USD₮', 'USD₮0', 'vbUSDT'],
  SWELL: ['wSWELL'],
  BERA: ['WBERA'],
  rUSD: ['srUSD'],
  WBTC: ['kBTC', 'vbWBTC'],
  wstETH: ['IAU_wstETH'],
  HYPE: ['WHYPE'],
  XPL: ['WXPL'],
  XAUt: ['XAUt0'],
  AVAX: ['wAVAX'],
  MON: ['WMON'],
  XTZ: ['WXTZ'],
}
